<div class="h-100 color-dark flex-column align-items-center px-5 login-status-page">
  <div class="w-100 flex-grow-1 flex-column align-items-center gap-5">
    <img class="login-status-animation" [src]="statusDetails().imageUrl" alt="" (load)="onAnimationLoad()" />
    <div class="w-100 relative login-status-text-area" aria-live="polite">
      @for (statusSwap of outgoingStatusSwaps(); track statusSwap.index) {
        <div class="absolute w-100 flex-column align-items-center gap-2 text-center login-status-text-outgoing" aria-hidden="true">
          <div class="text-28 bold-800 login-status-title login-status-title-outgoing" (animationend)="onOutgoingTextAnimationEnd()">
            {{ LoginStatusDetailsRecord[statusSwap.previousStatus].title }}
          </div>
          @if (LoginStatusDetailsRecord[statusSwap.previousStatus].text) {
            <div class="text-16 login-status-column login-status-subtitle-outgoing">
              {{ LoginStatusDetailsRecord[statusSwap.previousStatus].text }}
            </div>
          }
        </div>
      }
      @for (currentStatus of [status()]; track currentStatus) {
        <div
          class="w-100 flex-column align-items-center gap-2 text-center"
          [class.login-status-text-initial]="!hasStatusSwapped()"
          [class.login-status-text-swapped]="hasStatusSwapped()">
          <div class="text-28 bold-800 login-status-title">
            @for (word of titleWords(); track $index) {
              <span class="login-status-title-word" [style.--word-index]="$index">{{ word }}</span
              >&ngsp;
            }
          </div>
          @if (statusDetails().text) {
            <div class="text-16 login-status-column login-status-subtitle">{{ statusDetails().text }}</div>
          }
        </div>
      }
    </div>
    @if (status() === LoginStatusEnum.Error) {
      <button pButton type="button" class="p-button-primary centered login-status-column login-status-enter-late" (click)="onTryAgain()">
        Try again
      </button>
    }
    @if (status() === LoginStatusEnum.Expired && canSendNewSignInEmail()) {
      <div class="flex-column align-items-center gap-3 text-center login-status-column login-status-reveal login-status-reveal-cta">
        <button
          pButton
          type="button"
          class="p-button-primary centered w-100"
          [loading]="isSendingNewSignInEmail()"
          [disabled]="isSendingNewSignInEmail()"
          (click)="onSendNewSignInEmail()">
          Send new sign-in email
        </button>
        @if (hasNewSignInEmailFailed()) {
          <div class="flex align-items-center gap-1 text-14 color-dark">
            <shared-icon icon="danger-square" fill="var(--color-red)" height="1rem" width="1rem" />
            We couldn’t send a new email. Please try again.
          </div>
        }
      </div>
    }
  </div>
  <button
    pButton
    type="button"
    class="p-button-text primary centered login-status-escape-link"
    [class.login-status-escape-link-visible]="isEscapeLinkVisible()"
    [class.login-status-escape-link-delayed]="status() === LoginStatusEnum.Error"
    [class.login-status-reveal]="status() === LoginStatusEnum.Expired"
    [class.login-status-reveal-link]="status() === LoginStatusEnum.Expired"
    (click)="onGoToLoginPage()">
    Go to login page
  </button>
</div>
